import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Box, Typography, IconButton, useTheme, alpha } from '@mui/material';
import { Delete } from 'react-iconly';
const SectionPaper = ({ title, leftIcon, rightIcon, children, scrollable = false, maxHeight = '400px', className, sx, count, onDelete }) => {
    const theme = useTheme();
    return (_jsxs(Paper, { className: className, elevation: 0, sx: {
            borderRadius: theme.spacing(2),
            padding: theme.spacing(2),
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: 'transparent',
            position: 'relative',
            boxShadow: '0px 12px 24px -4px #919EAB1F, 0px 0px 2px 0px #919EAB33',
            ...sx
        }, children: [onDelete && (_jsx(IconButton, { onClick: onDelete, size: 'small', sx: {
                    position: 'absolute',
                    top: -15,
                    right: -15,
                    zIndex: 1,
                    backgroundColor: alpha(theme.palette.error.main, 0.12),
                    color: theme.palette.error.main,
                    '&:hover': {
                        backgroundColor: alpha(theme.palette.error.main, 0.2)
                    }
                }, children: _jsx(Delete, { size: 20 }) })), (title || leftIcon || rightIcon) && (_jsxs(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: theme.spacing(2),
                    paddingBottom: theme.spacing(1),
                    paddingRight: onDelete ? theme.spacing(4) : 0,
                    paddingLeft: count !== undefined ? theme.spacing(4) : 0,
                    borderBottom: `1px solid ${theme.palette.divider}`
                }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: theme.spacing(1) }, children: [leftIcon && (_jsx(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'absolute',
                                    top: -15,
                                    left: -15,
                                    zIndex: 1,
                                    width: 32,
                                    height: 32,
                                    borderRadius: theme.spacing(1),
                                    backgroundColor: theme.palette.primary.main,
                                    color: theme.palette.common.white
                                }, children: leftIcon })), title && (_jsx(Typography, { variant: 'h6', sx: {
                                    fontWeight: 600,
                                    color: theme.palette.text.primary,
                                    fontSize: '18px'
                                }, children: title }))] }), rightIcon && (_jsx(IconButton, { size: 'small', sx: {
                            color: theme.palette.text.secondary,
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover
                            }
                        }, children: rightIcon }))] })), _jsx(Box, { sx: {
                    flex: 1,
                    ...(scrollable && {
                        overflowY: 'auto',
                        maxHeight: maxHeight,
                        '&::-webkit-scrollbar': {
                            width: '6px'
                        },
                        '&::-webkit-scrollbar-track': {
                            backgroundColor: theme.palette.grey[100],
                            borderRadius: theme.spacing(1)
                        },
                        '&::-webkit-scrollbar-thumb': {
                            backgroundColor: theme.palette.grey[400],
                            borderRadius: theme.spacing(1),
                            '&:hover': {
                                backgroundColor: theme.palette.grey[600]
                            }
                        }
                    })
                }, children: children })] }));
};
export default SectionPaper;
